const USERS = {
  SET_USERS_QUERY: 'SET_USERS_QUERY',
  SET_USERS_INFINITE_QUERY: 'SET_USERS_INFINITE_QUERY',
  SET_USER_POSITIONS_QUERY: 'SET_USER_POSITIONS_QUERY',
};

export default USERS;
